import { combineReducers } from 'redux';
import {
	SHOW_GROUP_FEED,
  GET_DEVICE_PAIRING_LIST,
  GET_NEW_PAIRING_CODE,
  GET_LICENSES
} from 'signoxe/constants/actionTypes';

const currentDeviceId = (state=null, action)=>{
  if (action.type === SHOW_GROUP_FEED){
    return action.id
  } else {
    return state
  }
}

const initialState = {
  paring_codes: [],
  licenses : []
};

const deviceReducer = (state=initialState, action) => {

  console.log("Reducer", action.type)
  switch(action.type){

      case GET_DEVICE_PAIRING_LIST:
          return{
              ...state,
              paring_codes: action.payload
          };

      case GET_LICENSES:
          return{
              ...state,
              licenses: action.payload
          };

      default:
          return state;
  }
}



const deviceState = combineReducers({
  currentDeviceId,
  deviceReducer
});

export default deviceState;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/reducers/deviceState.js